import styled from 'styled-components';
import C from '@assets/themes/colors';

interface IRootProps {
    backgroundColor?: string;
    disabled?: boolean
    bgHover?: string;
}

export const Root = styled.div`
  display: flex;
  align-items: center;
  background-color: ${(props: IRootProps) => props.bgHover};
  &:hover {
    cursor: pointer;
    background-color: rgba(32, 64, 120, 0.05);
  }
`;